import Vue from 'vue';
import store from '../common/js/vuex/store';
import personalLoanCalculatorKo2021 from './personal-loan-calculator-ko-2021/personal-loan-calculator-ko-2021.vue';
import personalLoanCalculatorKo2021Store from './personal-loan-calculator-ko-2021/personal-loan-calculator-ko-2021-vuex';
if (!store.hasModule(['personalLoanCalculatorKo2021'])) {
	store.registerModule('personalLoanCalculatorKo2021', personalLoanCalculatorKo2021Store);
}
Vue.component('personal-loan-calculator-ko-2021', personalLoanCalculatorKo2021);
